import { Formik } from 'formik';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepShipmentFulfilled } from '../../../../actions/registerShipmentActions';
import IPageViewModel from '../../../../interfaces/umbracoNodes/pageViewModel';
import { IStore } from '../../../../reducers';
import { IRegisterShipmentReducer } from '../../../../reducers/registerShipmentReducer';
import { WizardPageProps } from '../../../wizard/wizard';
import { IStepInfoFormInfo } from '../stepInfo/stepInfo.schema';
import { StepShipmentSchema, StepShipmentSchema_ReceiverPhone } from './stepShipment.schema';
import * as StyledStepShipment from './stepShipment.styles';
import StepShipmentForm from './stepShipmentForm';

interface Props extends WizardPageProps {
	page: IPageViewModel;
}

const StepShipment: FC<Props> = ({ onSubmit, onPrevious }) => {
	const dispatch = useDispatch<any>();
	const { stepShipmentFormInfo } = useSelector(({ registerShipmentReducer }) => registerShipmentReducer);

	const registerShipmentReducer: IRegisterShipmentReducer = useSelector<IStore, IRegisterShipmentReducer>(
		store => store.registerShipmentReducer
	);

	const infoFormInfo: IStepInfoFormInfo = registerShipmentReducer.stepInfoFormInfo;

	const onStepShipmentSubmit = values => {
		dispatch(stepShipmentFulfilled(values));
		onSubmit(values);
	};

	return (
		<StyledStepShipment.Wrapper>
			<StyledStepShipment.FormWrapper>
				<Formik
					initialValues={stepShipmentFormInfo}
					enableReinitialize
					validationSchema={
						infoFormInfo.receiverPhone === '' ? StepShipmentSchema_ReceiverPhone : StepShipmentSchema
					}
					onSubmit={onStepShipmentSubmit}>
					{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, errors }) => (
						<StepShipmentForm
							values={values}
							errors={errors}
							onPrevious={onPrevious}
							setFieldTouched={setFieldTouched}
							setFieldValue={setFieldValue}
							isSubmitting={isSubmitting}
							isValid={isValid}
						/>
					)}
				</Formik>
			</StyledStepShipment.FormWrapper>
		</StyledStepShipment.Wrapper>
	);
};

export default StepShipment;
